import React from 'react'
import InputMask from 'react-input-mask'

const InputMaskCustom = React.forwardRef((props, ref) => {
  const { mask, ...other } = props

  return <InputMask {...other} inputRef={ref} mask={mask} maskChar="_" />
})

InputMaskCustom.displayName = 'InputMaskCustom'

export const telefoneMask = {
  inputComponent: InputMaskCustom,
  inputProps: { mask: '(99) 99999-9999' },
}

export const cpfMask = {
  inputComponent: InputMaskCustom,
  inputProps: { mask: '999.999.999-99' },
}

export const cnpjMask = {
  inputComponent: InputMaskCustom,
  inputProps: { mask: '99.999.999/9999-99' },
}

export const cepMask = {
  inputComponent: InputMaskCustom,
  inputProps: { mask: '99999-999' },
}

export const dataMask = {
  inputComponent: InputMaskCustom,
  inputProps: { mask: '99/99/9999' },
}

export const currencyMask = (valor) => {
  const formatador = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
  })
  return formatador.format(valor)
}
